<div class="floating-input-wrapper"
     [class.focused]="isFocused"
     [class.has-value]="hasValue"
     [class.disabled]="disabled">
  <div class="floating-input-container">
    <input
      type="text"
      class="floating-input"
      [class]="ngClass"
      [(ngModel)]="value"
      name="{{field.code}}"
      id="{{field.code}}"
      autocomplete="off"
      [disabled]="disabled"
      (focus)="dateRangePicker(true); onFocus()"
      (blur)="onBlur()"
      placeholder=" "
    />
    <label class="floating-label" [class.floating]="isFocused || hasValue">
      <img
        src="assets/icons/required-asterisk.svg"
        *ngIf="required"
        [attr.alt]="'alt.requiredField' | translate"
      >
      {{ label || field.placeHolder?.ru }}
      <!-- <span class="required-asterisk" *ngIf="required"></span> -->
    </label>
  </div>
</div>
<div class="dateRangePickerWrapper">
  <div class="input-group" *ngIf="dateRangePickerVisible">
    <ngb-datepicker class="dateRangePicker" #dp (select)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden">
    </ngb-datepicker>
    <ng-template #t let-date let-focused="focused">
      <span class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
  </div>
</div>
